import { render, staticRenderFns } from "./EntitiesTypeSettings.vue?vue&type=template&id=386b8d14&scoped=true"
import script from "./EntitiesTypeSettings.vue?vue&type=script&lang=js"
export * from "./EntitiesTypeSettings.vue?vue&type=script&lang=js"
import style0 from "./EntitiesTypeSettings.vue?vue&type=style&index=0&id=386b8d14&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "386b8d14",
  null
  
)

export default component.exports